import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import axios from 'axios';
import Header from "../common/Header";
import {buttonStyle, inputStyle} from "../styles";
import {BASIC_URL} from "../enum";

const ResetPassword = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('code');
    if (token) setCode(token);
  }, [location.search]);

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token) {
      navigate("/company");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!password || !passwordConfirmation) {
      setError(t('reset.error.required'));
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    if (!passwordRegex.test(password)) {
      setError(t('reset.error.weakPassword'));
      return;
    }

    if (password !== passwordConfirmation) {
      setError(t('reset.error.mismatch'));
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${BASIC_URL}/api/auth/reset-password`, {
        code,
        password,
        passwordConfirmation,
      });
      setSuccess(true);
      setPassword('');
      setPasswordConfirmation('');
      setLoading(false);
      navigate("/login");
    } catch (err) {
      console.error(err);
      setError(t('reset.error.failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth='xs' sx={{ pb: 3 }}>
        <Box mt={4} mb={3}>
          <Typography variant='h4' align='center' gutterBottom>
            {t('reset.title')}
          </Typography>
          <Typography variant='body1' align='center'>
            {t('reset.subtitle')}
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            margin='normal'
            label={t('reset.password')}
            type='password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={inputStyle}
          />
          <TextField
            fullWidth
            margin='normal'
            label={t('reset.confirm')}
            type='password'
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            required
            sx={inputStyle}
          />

          <Box mt={3} position='relative'>
            <Button type='submit' variant='contained' fullWidth disabled={loading} sx={buttonStyle}>
              {t('reset.submit')}
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{ position: 'absolute', top: '50%', right: '16px', mt: '-12px' }}
              />
            )}
          </Box>
        </form>

        {success && (
          <Box mt={2}>
            <Alert severity='success'>{t('reset.success')}</Alert>
          </Box>
        )}
        {error && (
          <Box mt={2}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}
      </Container>
    </>
  );
};

export default ResetPassword;
